import format from 'date-fns/format';

const TimeField = ({ value }) => format(value, 'DD.MM.YYYY');

export default TimeField;
